<template>
  <v-row dense>
    <v-col cols="12" md="6">
      <v-text-field
        v-model="busca"
        append-icon="mdi-magnify"
        label="Buscar por CPF, nome, turma ou série"
        clearable
        hide-details
        dense
        solo
      />
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-select
        :value="value.periodo_id"
        :items="periodos"
        :item-text="descreverPeriodo"
        item-value="id"
        label="Período"
        no-data-text="Nenhum período disponível"
        clearable
        hide-details
        dense
        solo
        @change="alterar({ periodo_id: $event })"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-select
        :value="value.status"
        :items="opcoesDeStatus"
        label="Status"
        clearable
        hide-details
        dense
        solo
        @change="alterar({ status: $event })"
      />
    </v-col>
  </v-row>
</template>

<script>
import { STATUS_PRE_MATRICULA, formatarData } from "./helpers";

/** Busca por texto e filtros de período e status, combináveis entre si. */
export default {
  name: "EFiltrosDePreMatriculas",
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      busca: this.value.busca,
      periodos: [],
      temporizador: null,
      opcoesDeStatus: Object.entries(STATUS_PRE_MATRICULA).map(([valor, { texto }]) => ({
        value: valor,
        text: texto,
      })),
    };
  },
  watch: {
    busca(texto) {
      clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.alterar({ busca: texto || "" }), 400);
    },
  },
  async mounted() {
    try {
      const resposta = await this.$services.preMatriculasService.listarPeriodos(1, 100);
      this.periodos = resposta.data;
    } catch (error) {
      // Sem permissão para ver os períodos, o filtro fica vazio e o resto da tela funciona.
    }
  },
  beforeDestroy() {
    clearTimeout(this.temporizador);
  },
  methods: {
    alterar(mudanca) {
      this.$emit("input", { ...this.value, ...mudanca });
    },
    descreverPeriodo(periodo) {
      const ano = periodo.ano ? `${periodo.ano.descricao} · ` : "";
      return `${ano}${formatarData(periodo.data_inicio)} a ${formatarData(
        periodo.data_fechamento
      )}`;
    },
  },
};
</script>
